import * as t from "io-ts";

import { ApiRetaillocatorStore } from "@thelabnyc/tsischemas/esm/codecs";

import { Latitude, Longitude } from "./nominals";
import { NullString, nullable } from "./utils";

export const RetailStore = t.readonly(ApiRetaillocatorStore);
export type RetailStore = t.TypeOf<typeof RetailStore>;

type IBaseLocation = Readonly<{
    formatted_address: string;
    formatted_address_long?: string;
}>;

export type ILocationZip = IBaseLocation &
    Readonly<{
        zip: string;
    }>;

export type ILocationLatLon = IBaseLocation &
    Readonly<{
        lat: Latitude;
        lng: Longitude;
    }>;

export type ILocation =
    | ILocationZip
    | ILocationLatLon
    | (ILocationZip & ILocationLatLon);

export const LocationGuessResponse = t.readonly(
    t.partial({
        as: NullString,
        city: NullString,
        country: NullString,
        countryCode: NullString,
        isp: NullString,
        lat: nullable(Latitude),
        lon: nullable(Longitude),
        org: NullString,
        query: NullString,
        region: NullString,
        regionName: NullString,
        status: NullString,
        timezone: NullString,
        zip: NullString,
    }),
);

export type ILocationGuessResponse = t.TypeOf<typeof LocationGuessResponse>;
